import {Component, Input, OnInit, OnChanges, ElementRef, ChangeDetectionStrategy} from '@angular/core';

import * as d3 from 'd3';

@Component({
  selector: 'app-pie-v4-objects',
  templateUrl: './pie-v4-objects.component.html',
  styleUrls: ['./pie-v4-objects.component.scss']
})
export class PieV4ObjectsComponent implements OnInit {
  private width: number =  800;
  private height: number = 400;
  private radius: number = null;
  private data: any[]= [
    { KeyValue: 1, DataValue: 10 } 
  , { KeyValue: 2, DataValue: 5}
  , { KeyValue: 3, DataValue: 3}
  , { KeyValue: 4, DataValue: 4}
  , { KeyValue: 5, DataValue: 6}
  , { KeyValue: 6, DataValue: 16}
  , { KeyValue: 7, DataValue: 17}
  , { KeyValue: 8, DataValue: 13}
  , { KeyValue: 9, DataValue: 2}
  , { KeyValue: 10, DataValue: 5}];

  private color: any;
  private pieGen: any;
  private pieData: any;
  private arcGen: any;

  private labelArcGen: any;

  element: ElementRef;
  constructor( e: ElementRef) {
    this.element = e;
    this.radius = Math.min(this.width, this.height) / 2;
  }

  ngOnInit() {
    this.generatePieChart();
  }

  generatePieChart() {

    this.color = d3.scaleOrdinal(d3.schemeCategory10).domain(this.data);
    this.pieGen = d3.pie()
      .sort(null)
      .value((this.GetData));
      
      

    this.pieData = this.pieGen(this.data);


    this.arcGen = d3.arc()
      .outerRadius(this.radius - 10)
      .innerRadius(0);

    this.labelArcGen = d3.arc()
      .outerRadius(this.radius - 40)
      .innerRadius(this.radius - 40);

    // CREATE THE SVG.
    const svg = d3.select(this.element.nativeElement)
      .append('svg')
      .attr('width', this.width)
      .attr('height', this.height)
      .append('g')
      .attr('transform', 'translate(' + this.width / 2 + ',' + this.height / 2 + ')');

    // ADD THE ARCS.
    const g = svg.selectAll('.arc')
      .data(this.pieData)
      .enter()
      .append('g')
      .attr('class', 'arc');

      // Add the fill to those.
      g.append('path').attr('d', this.arcGen)
      .style('fill', (d: any, i: any) => this.color(d.value) )// FILL COLOR. -- THIS IS NOT THE FIELD NAME. This the 'value' of the datum.
      .style('stroke', 'black') // OUTLINE.
      .style('stroke-width', '1px'); // OUTLINE WIDTH

      g.append('text')
      .attr('transform', (d: any) => 'translate(' + this.labelArcGen.centroid(d) + ')')
      .attr('dy', '.35em')
      .text((d: any, i:any) => i.toString()+":"+d.value.toString());
  }

  GetData(d): number  {
      return d.DataValue;
  }
}